"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Switch = (props) => {
    const child = props.children.find((child) => {
        return child.props.identifier === props.case ? child : null;
    });
    return child ? child : props.default;
};
exports.default = Switch;
